// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__3lCXe","error":"Textarea_error__3zzsd","readonly":"Textarea_readonly__xg4e7","disabled":"Textarea_disabled__1Ovzm"};